type Props = {
  totalQuantity: number;
  totalPrice: number;
  discountAmount: number;
  finalPrice: number;
  coupon?: { code: string };
  isMobile?: boolean;
};

const CartSummary = ({
  totalQuantity,
  totalPrice,
  discountAmount,
  finalPrice,
  coupon,
  isMobile,
}: Props) => (
  <div
    className={`border-t pt-4 text-right space-y-1 text-gray-700 ${
      isMobile ? "text-base" : "text-lg"
    }`}
  >
    <div className='flex justify-between'>
      <span>عدد الأصناف:</span>
      <span className='text-red-600'>{totalQuantity} أصناف</span>
    </div>
    <div className='flex justify-between'>
      <span>السعر قبل الخصم:</span>
      <span>{totalPrice.toFixed(2)} ريال</span>
    </div>
    {coupon && (
      <div className='flex justify-between'>
        <span className={isMobile ? "text-sm" : ""}>
          الخصم ({coupon.code}):
        </span>
        <span className='text-green-600'>
          - {discountAmount.toFixed(2)} ريال
        </span>
      </div>
    )}
    <div
      className={`flex justify-between font-bold ${
        isMobile ? "text-lg border-t pt-2 mt-2" : ""
      }`}
    >
      <span>السعر النهائي:</span>
      <span className='text-red-600'>{finalPrice.toFixed(2)} ريال</span>
    </div>
  </div>
);

export default CartSummary;
